import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion";

const PILLS = [
  { label: "Fractional management", featured: true },
  "Marketing",
  "Finanza",
  "Finanza agevolata",
  "Risorse umane",
  "Consulenza del lavoro",
  "Consulenza legale",
  "Organizzazione aziendale",
  "Controllo di gestione",
  "Formazione",
  "Contabilità",
];

export const ServicesTeaser = () => (
  <section className="bg-[#FACC15] text-black py-14 sm:py-16 overflow-hidden" data-testid="services-teaser">
    <Reveal className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col sm:flex-row sm:items-end justify-between gap-6" y={20}>
      <div>
        <p className="eyebrow-dark mb-3">Servizi</p>
        <h2
          className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-[1.05]"
          style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.03em" }}
          data-testid="services-h2"
        >
          Undici aree, un'unica regia
        </h2>
      </div>
      <Link
        to="/servizi"
        className="btn-black inline-flex items-center gap-2 self-start sm:self-auto group"
        data-testid="home-link-tutti-servizi"
      >
        Scopri tutti i servizi
        <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
      </Link>
    </Reveal>

    <div className="marquee-mask mt-10" aria-label="Aree di servizio">
      <ul className="marquee-track gap-3 pr-3" data-testid="services-marquee">
        {[...PILLS, ...PILLS].map((p, i) => {
          const label = p.label || p;
          return (
            <li
              key={`${label}-${i}`}
              className={`lift lift-dark whitespace-nowrap text-lg sm:text-xl border px-6 py-3 ${
                p.featured ? "bg-black text-[#FACC15] border-black font-bold" : "border-black/60"
              }`}
              style={{ fontFamily: "'Outfit', sans-serif" }}
              data-testid={p.featured ? "service-pill-featured" : "service-pill"}
            >
              {label}
            </li>
          );
        })}
      </ul>
    </div>
  </section>
);

export default ServicesTeaser;
